// This list isn't exhaustive and doesn't control the entire feature across the stack - these config
// entries toggle ONLY FRONTEND BEHAVIORS - see backend code for toggling backend behaviors
//
// See also related config in Events::EventOwnerTypeConfig in backend
//
// Please keep each list of feature keys in alpha order

export const eventOrganizedAsConfig: {
  [key: string]: {
    artistSelfBooking: boolean;
    bookingEventRole: boolean;
    bookingFee: boolean;
    businessOwner: boolean;
    crewAvailability: boolean;
    crewEventBreakingNews: boolean;
    crewPortal: boolean;
    experimentalEvent: boolean;
    formatType: boolean;
    maxPaInputs: boolean;
    smsSignup: boolean;
    viewEventRevenue: boolean;
    visaPresale: boolean;
  };
} = {
  o_and_o: {
    artistSelfBooking: true,
    bookingEventRole: true,
    bookingFee: true,
    businessOwner: true,
    crewAvailability: true,
    crewEventBreakingNews: true,
    crewPortal: true,
    experimentalEvent: true,
    formatType: true,
    maxPaInputs: true,
    smsSignup: true,
    viewEventRevenue: true,
    visaPresale: true,
  },
  producer: {
    artistSelfBooking: true,
    bookingEventRole: true,
    bookingFee: true,
    businessOwner: true,
    crewAvailability: true,
    crewEventBreakingNews: true,
    crewPortal: true,
    experimentalEvent: true,
    formatType: true,
    maxPaInputs: true,
    smsSignup: true,
    viewEventRevenue: true,
    visaPresale: true,
  },
  curator_owner_commercial_event: {
    artistSelfBooking: false,
    bookingEventRole: false,
    bookingFee: true,
    businessOwner: false,
    crewAvailability: false,
    crewEventBreakingNews: false,
    crewPortal: false,
    experimentalEvent: false,
    formatType: false,
    maxPaInputs: false,
    smsSignup: false,
    viewEventRevenue: false,
    visaPresale: false,
  },
  curator_owner_noncommercial_event: {
    artistSelfBooking: false,
    bookingEventRole: false,
    bookingFee: false,
    businessOwner: false,
    crewAvailability: false,
    crewEventBreakingNews: false,
    crewPortal: false,
    experimentalEvent: false,
    formatType: false,
    maxPaInputs: false,
    smsSignup: false,
    viewEventRevenue: false,
    visaPresale: false,
  },
};
